export enum ActivationKind {
    BUTTON = 0,
    ON_SAVE = 1,
    ON_CREATE = 2,
    ON_DELETE = 3,
    BEFORE_CREATE = 4,
    ON_SAVE_OR_CREATE = 5
}
